import { Component, OnDestroy } from '@angular/core';
import { SettingsService, } from '../settings.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { WhitelabelInformationModel } from 'src/app/models/whitelabel-information.model';
import { Observable, OperatorFunction, Subscription, debounceTime, switchMap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/models/user';
import { ChangeWhiteLabelModal } from '../components/change-whitelabel/change-whitelabel.modal';
import { IdsForSettingsService, OrganisationInfoModel, WhiteLabelInfoModel } from '../ids-for-settings.service';
import { IdentitySystemApiClient } from 'src/app/services/api-clients/identity-system.api-client';

@Component({
  templateUrl: './whiteLabel.layout.html'
})
export class WhiteLabelLayout implements OnDestroy {

  selectedWhiteLabelName: string = "";
  whiteLabelNameSubscription!: Subscription;
  user!: User;
  modalRef!: NgbModalRef;
  
  searchWhiteLabel: OperatorFunction<string, WhitelabelInformationModel[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      switchMap((search) =>
        search.length < 2 ? [] : this.identitySystemApiClient.getFilteredWhiteLabel(this.settingsService.systemGuid, search)
      ),
    );

    constructor(private modalService: NgbModal, private settingsService: SettingsService, private idsForSettingsService: IdsForSettingsService, private identityWhitelabelApiClient: IdentityWhitelabelApiClient, private identitySystemApiClient: IdentitySystemApiClient, private router: Router, private route: ActivatedRoute) {
    this.user = this.settingsService.user;
    // subscribe so we can update the name
    this.whiteLabelNameSubscription = this.idsForSettingsService.selectedWhiteLabelName$.subscribe(whiteLabelName => {
      this.selectedWhiteLabelName = whiteLabelName;
    });
  }

  ngOnInit() {
    let whiteLabelId = this.route.snapshot.paramMap.get('whiteLabelId');
    if (whiteLabelId == null || whiteLabelId == "") {
      return;
    }
    this.identityWhitelabelApiClient.getWhitelabel(whiteLabelId).subscribe(whitelabelData => {
      this.idsForSettingsService.setSelectedOrganisation(new OrganisationInfoModel(whitelabelData?.whiteLabel?.guid, whitelabelData?.whiteLabel?.name));
    });
    this.settingsService.getwhitelabel(whiteLabelId!, this.user);
  }

  ngOnDestroy() {
    this.whiteLabelNameSubscription.unsubscribe();
  }

  openChangeWhiteLabelModal(){
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    this.modalRef = this.modalService.open(ChangeWhiteLabelModal, ngbModalOptions);
    this.modalRef.componentInstance.systemGuid = this.settingsService.systemGuid
    this.modalRef.componentInstance.whiteLabelInfo.subscribe((whiteLabelInfo: WhiteLabelInfoModel) => {
      if(!whiteLabelInfo) return;
      this.selectedWhiteLabelName = whiteLabelInfo.whiteLabelName;
        this.idsForSettingsService.setSelectedWhitelabel(whiteLabelInfo);
    });    
  }
}
